import io from "socket.io-client";
import config from "./index";

const socket = io(config.API_URL)

export { socket }